export default __webpack_public_path__ + "static/media/logob.5c4ed626.png";